export const ActionCard = {
    height: '91px',
    borderRadius: '24px',
    padding: '25px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
};
export const Card = {
    borderRadius: '25px',
    background: 'white',
    padding: '25px'
};
export const FlexGap = {
    display: 'flex',
    alignItems: 'center',
    gap: 2
};
export const JustifyBetween = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
};
export const IconBox = {
    width: "30px",
    height: "30px",
    borderRadius: "50%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
};
